// use effect but call only if value != new
import {DependencyList, EffectCallback, useEffect, useRef} from "react";

export const useMemoryEffect = (effect: EffectCallback, deps: DependencyList, ignoreFirstTime: boolean = false) => {
	const ref = useRef([] as DependencyList);
	const refIsFIrst = useRef(true);
	useEffect(() => {
		// compare every value
		if (ref.current.some((value, index) => value !== deps[index]) || ref.current.length !== deps.length)
		{
			if (ignoreFirstTime && refIsFIrst.current)
			{
				refIsFIrst.current = false;
				ref.current = deps;
				return;
			}

			ref.current = deps;
			return effect();
		}
	}, deps);
}

export default useMemoryEffect;